export default __webpack_public_path__ + "static/media/tab2.f664526d.jpg";